<template>
    <div class="DashboardSummary">
        <h1 class="center-text">Summary {{SummaryWeekOfLabel}}</h1>
        <h3 class="center-text">{{ LoadingLabel }}</h3>
        <div class="row"  style="margin-top:35px;">
            <div class="col">
                <table class="table-utility" style="margin-bottom: 50px;">
                    <tbody v-for="section in Sections">
                        <tr>
                            <th colspan="8" class="center-text"><h3 style="margin-top:35px;"> {{section}} </h3></th>
                        </tr>
                        <tr>
                            <th>Metric</th>
                            <th>Combined</th>
                            <th>OC</th>
                            <th>LA</th>
                            <th>IE</th>
                            <th>PNW</th>
                            <th>Nevada</th>
                            <th>Santa Barbara</th>
                        </tr>
                        <tr v-for="dashboardRow in DashboardData[section]">
                            <td><span class="link-like" @click="ChangeParentPane(dashboardRow.MetricPane)"> {{dashboardRow.MetricDescription}} </span> <span v-b-tooltip.hover :title="dashboardRow.MetricDefinition"><i class="fa fa-info" /></span> </td>

                            <td v-for="region in Regions">
                                <div v-if="dashboardRow.RegionSummaries[region]">
                                    <span class="bold" :class="{red: !dashboardRow.RegionSummaries[region].CountMeetsTarget, green: dashboardRow.RegionSummaries[region].CountMeetsTarget}"> {{dashboardRow.RegionSummaries[region].ActualByTarget}} </span>
                                </div>
                                <div v-else>
                                    <span class="bold"></span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>


        
    </div>
</template>

<script>
    //import components

    export default {
        name: "DashboardSummary",
        props: [
            "StartDate",
            "EndDate"
        ],
        data: function () {
            return {
                DashboardData: {},
                EndpointIndex: 0,
                Regions: [
                    "Combined",
                    "Orange County",
                    "Los Angeles",
                    "Inland/Desert",
                    "PNW",
                    "Las Vegas",
                    "Santa Barbara"
                ],
                Sections: [
                    "Families",
                    "Census",
                    "QA",
                    "Fund Development",
                    "Church Engagement"
                ],
                MetricEndpoints: [
                    {
                        Endpoint: "FosterInquiries",
                        CoreProgramID: "",
                        Section: "Families"
                    },
                    {
                        Endpoint: "HostInquiries",
                        CoreProgramID: "",
                        Section: "Families"
                    },
                    {
                        Endpoint: "FosterApplicantsInProgress",
                        CoreProgramID: "",
                        Section: "Families"
                    },
                    {
                        Endpoint: "HostActivations",
                        CoreProgramID: "",
                        Section: "Families"
                    },
                    {
                        Endpoint: "FosterAvailableBeds",
                        CoreProgramID: "",
                        Section: "Families"
                    },
                    {
                        Endpoint: "ClientAverageDailyCensus",
                        CoreProgramID: "",//Organizational
                        Section: "Census"
                    },
                    {
                        Endpoint: "ClientAverageDailyCensus",
                        CoreProgramID: "2E25AACC-64C2-4283-976D-DEA8B5052FA6",//Foster
                        Section: "Census"
                    },
                    {
                        Endpoint: "ClientAverageDailyCensus",
                        CoreProgramID: "15A44C4E-9500-4706-B363-F0B7670B862C",//Residential
                        Section: "Census"
                    },
                    {
                        Endpoint: "ClientAverageDailyCensus",
                        CoreProgramID: "FF8A6236-ACBA-4DFC-8A3C-610E41AECCB9",//TAY
                        Section: "Census"
                    },
                    {
                        Endpoint: "ClientAverageDailyCensus",
                        CoreProgramID: "4B61365B-0C2F-4CE9-8BB0-D79584938614",//Wraparound
                        Section: "Census"
                    },
                    {
                        Endpoint: "ContactsWithClients",
                        CoreProgramID: "2E25AACC-64C2-4283-976D-DEA8B5052FA6",//Foster
                        Section: "QA"
                    },
                    {
                        Endpoint: "RaisersEdgeMeetings",
                        CoreProgramID: "",
                        Section: "Fund Development",
                        ChurchOnly: false
                    },
                    {
                        Endpoint: "RaisersEdgeMeetings",
                        CoreProgramID: "",
                        Section: "Church Engagement",
                        ChurchOnly: true
                    },
                    {
                        Endpoint: "FosterActivations",
                        CoreProgramID: "",
                        Section: "Families"
                    }

                ]
            };
        },
        methods: {
            GetData() {
                let vm = this;
                vm.DashboardData = {};
                vm.Sections.forEach(function (section) {
                    vm.DashboardData[section] = [];
                });
                vm.EndpointIndex = 0;
                vm.GetDataDashboardRow();
            },
            GetDataDashboardRow() {
                if (this.MetricEndpoints.length > this.EndpointIndex) {
                    let row = this.MetricEndpoints[this.EndpointIndex];
                    this.$MasterAPI.ExecuteRequest("GET", "Dashboards/Executive/" + row.Endpoint, { StartDate: this.StartDate, EndDate: this.EndDate, FirstWeekOnly: true, CoreProgramID: row.CoreProgramID, ChurchOnly: row.ChurchOnly }, this.GetDataDashboardRowSuccess, this.GetDataDashboardRowError, false);
                }
            },
            GetDataDashboardRowSuccess(response) {
                this.DashboardData[this.MetricEndpoints[this.EndpointIndex].Section].push(response.data.data);
                this.$forceUpdate();
                this.EndpointIndex++;
                this.GetDataDashboardRow(this.EndpointIndex);

            },
            GetDataDashboardRowError(response) {
                this.DashboardData[this.MetricEndpoints[this.EndpointIndex].Section].push({
                    MetricDefinition: "An error occurred while fetching this metric.  You can try to refresh the page, or contact support if the problem persists.",
                    MetricDescription: "ERROR ON: " + this.MetricEndpoints[this.EndpointIndex].Endpoint,
                    MetricPane: null,
                    RegionSummaries: []
                });
                this.$forceUpdate();
                this.EndpointIndex++;
                this.GetDataDashboardRow(this.EndpointIndex);

            },
            DashboardSection(sectionName) {
                console.log(sectionName);
                console.log(this.DashboardData[sectionName]);
                let sec = this.DashboardData[sectionName];
                if (sec) {
                    return sec;
                } else {
                    return [];
                }
            },
            ObjectToArray(obj) {
                let keys = Object.keys(obj);
                let output = [];
                keys.forEach(function (key) {
                    output.push(obj[key]);
                })
                return output;
            },

            SeriesDataForRegion(regionName) {
                let output = [];
                this.DashboardData.forEach(function (dateRange) {
                    output.push(dateRange.RegionSummaries[regionName].SeriesData);
                });
                return [{
                    name: "Actual",
                    data: output
                }];
            },

            ChangeParentPane(paneName) {
                console.log("changing from summary page to " + paneName)
                this.$parent.ChangePaneShown(paneName);
            },

            formatDate(value, fmt = 'MM/DD/YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
        },
        watch: {
            StartDate(newDate, oldDate) {
                this.GetData();
            },
            EndDate(newDate, oldDate) {
                this.GetData();
            }
        },
        components: {

        },
        mounted() {
            this.GetData();
            
        },
        computed: {
            SummaryWeekOfLabel: function () {
                return "Week of " + this.formatDate(this.EndDate);
            },
            IsDoneLoading: function () {
                if (this.TotalMetrics == this.EndpointIndex) {
                    return true;
                } else {
                    return false;
                }
            },
            LoadingLabel: function () {
                let metricsLength = this.MetricEndpoints.length;
                if (metricsLength != this.EndpointIndex) {
                    return "Loading " + this.EndpointIndex + " of " + metricsLength + " Metrics...";
                } else {
                    return "";
                }
            }
        }
    }
</script>

<style scoped>

</style>